import { differenceInMinutes } from 'date-fns';
import * as Yup from 'yup';

import { mergeDateTime } from '../../components/RideForm/RideForm.helpers';

export const editRideValidationSchema = (timeZone, previousTime) =>
  Yup.object().shape({
    timeAnchor: Yup.string().required('Required Field'),
    anchorTime: Yup.date().required('Required Field'),
    time: Yup.string().required('Required Field'),
    adjustmentReasonKey: Yup.string().when(['time', 'anchorTime'], {
      is: (time: string, anchorTime: Date) => {
        const hours = time.split(':')[0];
        const minutes = time.split(':')[1];
        const timeChangedBy15Min =
          previousTime.split(':')[0] !== hours ||
          Math.abs(parseInt(previousTime.split(':')[1]) - parseInt(minutes)) >= 15;
        const combinedTime = mergeDateTime(anchorTime, timeZone, time).getTime();
        const lessThan2Hours = differenceInMinutes(new Date(combinedTime), new Date()) < 120;

        return timeChangedBy15Min && lessThan2Hours;
      },
      then: Yup.string().required('Adjustment Reason Key is required'),
      otherwise: Yup.string(),
    }),
    waypointsAttributes: Yup.array()
      .min(1)
      .of(
        Yup.object().shape({
          anchor: Yup.boolean().required(),
          id: Yup.number().required(),
          passengerIdsStrings: Yup.array().min(1, 'Required Field').of(Yup.string()),
          accountLocationAttributes: Yup.object().shape({
            address: Yup.string().required('Required Field'),
            accountId: Yup.number().required('Required Field'),
            placeId: Yup.string().required('Required Field'),
          }),
        })
      ),
  });
